
  <div [class.table-wrapper]="fixedHeader()" [style.max-height]="maxHeight()">
    <table class="woo-table table--info table--hover table--small" [class.table--layout--fixed]="fixedLayout()">
      <thead>
        @if (hasGroupRow()) {
          <tr class="group-header-row">
            @for (seg of groupSegments(); track seg.key) {
              <th
                class="centered"
                scope="colgroup"
                [class.grouped]="seg.isGroup"
                [class.ungrouped]="!seg.isGroup"
                [attr.colspan]="seg.colspan"
                [class.sticky-th]="fixedHeader()">
                @if (seg.tpl) {
                  <ng-container
                    [ngTemplateOutlet]="seg.tpl"
                    [ngTemplateOutletContext]="{ count: seg.colspan }">
                  </ng-container>
                } @else {
                  {{ seg.label }}
                }
              </th>
            }
          </tr>
        }
        <tr>
          @for (col of columnDefs(); track col.name() ) {
            <th class="pointer" (click)="toggleSort(col.name)" [class.sticky-th]="fixedHeader()">
              {{ col.header() }}
  
              @if (sortColumn() === col.name()) {
                <span>{{ sortDirection() === 'asc' ? '▲' : '▼' }}</span>
              }
            </th>
          }
        </tr>
      </thead>
      <tbody>
      @if (sortedData()?.length) {
        @for (row of sortedData(); track row.id; let rowIndex = $index) {
          <tr>
            @for (col of columnDefs(); track col.name(); let isLast = $last; let colIndex = $index; ) {
              <td class="table-cell-padding" (click)="$event.stopPropagation(); toggleExpandedAt(rowIndex)" [style.cursor]="expandable() ? 'pointer' : 'default'">
                @if (col.template()) {
                  <ng-container
                    [ngTemplateOutlet]="col.template()"
                    [ngTemplateOutletContext]="{ $implicit: { row: row, columnKey: col.name(), column: col, value: row[col.name()], index: colIndex, rowIndex: rowIndex,  setCell: setCell } }">
                  </ng-container>
                } @else {
                  {{ row[col.name()] ?? emptyCellText() ?? '-' }}
                }

                @if (isLast && expandable()) {
                  <button
                    type="button"
                    class="expander inline-flex items-center gap-1 mr-2"
                    [attr.aria-expanded]="isExpandedAt(rowIndex)"
                    [attr.aria-controls]="'row-detail-' + rowIndex"
                    [attr.aria-label]="isExpandedAt(rowIndex) ? 'Collapse row' : 'Expand row'">
                    <span
                      class="chev medium text--info"
                      [class.open]="isExpandedAt(rowIndex)">
                    </span>
                </button>
                }
              </td>
            }
          </tr>
        
          @if (expandable() && isExpandedAt(rowIndex)) {
            <tr class="expanded-data" [attr.id]="'row-detail-' + rowIndex">
              <td [attr.colspan]="columnDefs().length" class="table-cell-padding">
                @if (expandedTpl()) {
                  <ng-container
                    [ngTemplateOutlet]="expandedTpl()"
                    [ngTemplateOutletContext]="{
                      $implicit: { row: row, index: rowIndex } }
                    ">
                  </ng-container>
                }
                @if(debug()) {
                  {{ row | json }}
                }
              </td>
            </tr>
          }
        }
        
  
        @if (sumTitle()) {
            <tr class="table-summary-row font-bold bg-gray-100">
                @for (col of columnDefs(); track col.name()) {
                    <td class="table-cell-padding">
                        @if ($index === 0) {
                            {{ sumTitle() }}
                        } @else {
                            @if (col.template() && columnSums()[col.name()] !== undefined) {
                                <ng-container
                                  [ngTemplateOutlet]="col.template()"
                                  [ngTemplateOutletContext]="{ $implicit: { row: null, columnKey: col.name(), column: col, value: columnSums()[col.name()], isSummary: true } }
                                ">
                                </ng-container>
                            } @else {
                                @if (isNumeric(columnSums()[col.name()])) {
                                {{ columnSums()[col.name()] }}
                                } @else {
                                    -
                                }
                            }
                        }
                    </td>
                }
            </tr>
          }
        } @else {
          @if(loaderTpl()) {
              <td [attr.colspan]="columnDefs().length" class="table-cell-padding">
                <ng-container
                  [ngTemplateOutlet]="loaderTpl()"
                  [ngTemplateOutletContext]="{ $implicit: {} }
                    ">
                </ng-container>
              </td>
          } @else {
            <tr>
              <td class="table-cell-padding w-100" [attr.colspan]="columnDefs().length">Ingen data tillgänglig</td>
            </tr>
          }

        }
      </tbody>
    </table>
  </div>


@if(debug()) {
  <div class="debug-container">
    <h3>Debug</h3>
    <p>Sorted Data: {{ sortedData() | json }}</p>
    <p>Column Defs: {{ columnDefs() | json }}</p>
    <p>Column Sums: {{ columnSums() | json }}</p>
  </div>
}
